module.exports = __webpack_public_path__ + "static/img/testimony (62).9f5df8a8.jpg";